import { Account } from './Account';
import type { QueriesType } from '../telematics/types';
import { SettingsApi } from '../Settings/SettingsApi';
import { get } from 'svelte/store';
import { api } from '../../../stores/api';
import { Api } from '@automapa/svelte-automapa-template';

export class AccountApp {
    private _accounts: Account[] = [];
    private _onlyMyAccounts: boolean = false;
    private _loaded: boolean = false;

    constructor(onlyMyAccounts: boolean = false) {
        this._onlyMyAccounts = onlyMyAccounts;
    }

    public async prepareData(api: Api): Promise<this> {
        let response = await SettingsApi.getDemoAccounts(api, this._onlyMyAccounts).catch(() => {
            console.error('Error fetching accounts');
        });
        if (response) {
            this._accounts = [];
            response.forEach(account => {
                this._accounts.push(new Account().set(account, account?.webuser_id ?? null));
            });
            console.log('AccountApp, fetched accounts:', this._accounts.length);
        } else {
            console.error('No accounts found');
            this._accounts = [];
        }
        this._loaded = true;
        return this;
    }

    public isLoaded() {
        return this._loaded;
    }

    public async getAllItems() {
        return this._accounts;
    }

    public getCustomerIdsAsItems(): { id: string; label: string }[] {
        let list = this._accounts.map(account => {
            let id = account.getCustomerId();
            let accountName = account.getName();
            return {
                id: account.getCustomerId()?.toString() ?? '',
                label: `[${id}] - ${accountName}`,
            };
        });
        // sort list by id
        list.sort((a, b) => {
            return parseInt(a.id) - parseInt(b.id);
        });
        return list;
    }

    public async getFilteredItems(
        filter: string,
        showTechnicalAccounts: boolean = false,
        showStandardAccounts: boolean = true
    ) {
        return this._accounts.filter(
            account =>
                (filter === '' ||
                    account.getCustomerId()?.toString() === filter ||
                    account.getName().toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
                    account.getEmail().toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
                    account.getExpirationDate()?.includes(filter)) &&
                (showTechnicalAccounts || !account.isTechnical()) &&
                (showStandardAccounts || account.isTechnical())
        );
    }

    public async save(account: Account) {
        alert('this feature is not implemented yet');
        // if (account.isNew()) {
        //     return Account.createOne(account.get());
        // }
        // return Account.updateOne(account.getId(), account.get());
    }

    public async updateExpirationDate(api: Api, account: Account) {
        let config = await SettingsApi.getCustomerSettings(api);
        return SettingsApi.setCustomerSettings(
            api,
            {
                ...config.settings,
                expiration_date: account.getExpirationDate(),
            },
            account.getCustomerId()
        );
    }

    public async create(api: Api, account: Account) {
        return SettingsApi.createDemoAccount(
            api,
            account.getName(),
            account.getEmail(),
            account.getExpirationDate(),
            account.getCustomerId()
        );
    }
}
